import NAVIGATORS from '@src/NAVIGATORS';
import SCREENS from '@src/SCREENS';

const BOTTOM_TAB_SCREENS = [SCREENS.HOME, SCREENS.SETTINGS.ROOT, NAVIGATORS.BOTTOM_TAB_NAVIGATOR];

export default BOTTOM_TAB_SCREENS;
